<template>
  <div class="table">
    <el-table
      :data="leaveApprovalSettingsData"
      @selection-change="handleSelectionChange"
      style="width: 100%"
      empty-text=""
      v-loading="loading || overlayLoading"
    >
      <div slot="empty">
        <NoDataToView
          v-if="!loading"
          link="/admin/hrm/leave/settings/leave-approval/create"
          :showButton="showCreateLeaveApproverLink"
          btnText="Leave Approver"
        >
          <template slot="message">
            <p>
              {{ noDataMessage }} &nbsp;<button
                v-if="!showCreateLeaveApproverLink"
                @click="$emit('resetTable')"
                class="pointer blue underline"
              >
                clear
              </button>
            </p>
          </template>
        </NoDataToView>
      </div>
      <el-table-column type="selection" width="50"></el-table-column>
      <el-table-column
        sortable
        prop="id"
        label="ID"
        width="100"
      ></el-table-column>
      <el-table-column
        sortable
        prop="description"
        label="EMPLOYEE GROUP"
        align="center"
      ></el-table-column>
      <el-table-column
        sortable
        prop="no_approvals"
        label="No Of Approvers"
        align="center"
      ></el-table-column>
      <el-table-column sortable prop="actions" label="ACTIONS">
        <template scope="scope">
          <div class="actions">
            <button @click="$emit('toggleView', scope.row)">
              <img src="/img/view.svg" alt="view" />
            </button>
            <button @click="editLeaveApprover(scope.row.id)">
              <img src="/img/pencil-edit.svg" alt="edit" />
            </button>
            <button @click="deleteALeaveApprover(scope.row.id)">
              <img src="/img/delete.svg" alt="delete" />
            </button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-container">
      <el-pagination
        mini
        @size-change="handleSizeChangeApproval"
        @current-change="handleCurrentChangeApproval"
        :current-page.sync="currentPage"
        :page-sizes="pageSizes"
        :page-size="perPage"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapState, mapActions } = createNamespacedHelpers("admin/hrm/leave");
import NoDataToView from "@/components/general/NoDataToView.vue";

export default {
  components: {
    NoDataToView,
  },
  props: ["resetTable", "searchQuery", "overlayLoading"],
  mounted() {
    this.searchLeaveApprovers();
  },
  data() {
    return {
      pageSizes: this.$store.state.admin.pageSizes,
    };
  },
  computed: {
    showCreateLeaveApproverLink() {
      return !this.searchQuery && !this.leaveApprovalSettingsData.length;
    },
    noDataMessage() {
      let message = `No Leave Approval available`;
      if (this.showCreateLeaveApproverLink) {
        return message;
      }
      return `${message} ${this.searchQuery ? "for " : ""} ${
        this.searchQuery
      } `;
    },
    ...mapState({
      leaveApprovalSettingsData: "leaveApprovers",
      total: "totalLeaveApprover",
      loading: "tableLoading",
      perPage: "perPage",
    }),
    currentPage: {
      get() {
        return this.$store.state.admin.hrm.leave.currentPage;
      },
      set(value) {
        return this.$store.commit("admin/hrm/leave/currentPage", value);
      },
    },
  },
  methods: {
    ...mapActions([
      "handleSizeChangeApproval",
      "handleCurrentChangeApproval",
      "deleteLeaveApprover",
    ]),
    searchLeaveApprovers() {
      this.$store
        .dispatch("admin/hrm/leave/searchLeaveApprovers")
        .then(() => {})
        .catch(error => {
          this.$notification.error(error.message, { offset: 100 });
        });
    },
    toggleView() {
      this.$emit("toggleView");
    },
    handleSelectionChange(val) {
      this.$emit("handleSelectionChange", val);
    },
    editLeaveApprover(id) {
      this.$router.push({ name: "edit-leaveApprover", params: { id } });
    },
    deleteALeaveApprover(id) {
      this.$promptModal(
        "Delete Leave Approver",
        "This Leave Approver will be deleted",
        "Delete",
        () => this.handleDleteLeaveApprover(id)
      );
    },
    handleDleteLeaveApprover(id) {
      this.loading = true;
      this.deleteLeaveApprover(id)
        .then(() => {
          this.loading = false;
          this.searchLeaveApprovers();
        })
        .catch(error => {
          this.loading = false;
          this.$notification.error(error.message);
        });
    },
  },
};
</script>
